import React, { useState, useEffect } from "react";
import { useGetBuyerListByIdQuery} from "./ProcurementApiSlice";

import CreateBuy from "./CreateBuy";
import CustomTable from "components/CustomTable";
import { Typography,Box,CardContent ,Grid,Card} from "@mui/material";
import {  Tag } from 'antd';
import { Avatar } from 'antd';
import SkeletonLoader from "./SkeletonLoader";
import {
  CheckCircleOutlined,ClockCircleOutlined} from '@ant-design/icons';
import NoData from "features/MobileProcurement/NoData";
const BuyerLeadList = ({ user_id ,UserData,activeCard,triggerTab2Api}) => {
  const { data: buyerList ,isLoading,refetch} = useGetBuyerListByIdQuery(user_id);
  const [pagination, setPagination] = useState({ page: 1, per_page: 10 });
  const [stockData, setStocksData] = useState([])
  const [widthShow, setWidth] = useState(true);
     useEffect(() => {
        if (triggerTab2Api) {
          refetch()
        }
      }, [triggerTab2Api]);
  useEffect(() => {
      if(buyerList){
        setStocksData(buyerList?.data)
    }
  }, [buyerList,activeCard]);
 
  const columns = [
    { field: "crop_name", headerName: "Commodity", width: 260 ,
    renderCell: (cellvalues) => {
      return (
        <div className="text-center mx-1"><Avatar
        style={{
          backgroundColor: '#fde3cf',
          color: '#f56a00',
        }}
      >
         {cellvalues?.row?.crop_name.slice(0, 1)}
      </Avatar> &nbsp;{cellvalues?.row?.crop_name} </div>
      );
    },
  
  },

    { field: "quantity", headerName: "Quantity", width: 150,
    renderCell: (cellvalues) => {
      return (
        <div className="text-center">{cellvalues?.row?.quantity} {cellvalues?.row?.unit_of_measure==="Quintal"? "Qtl.":"MT"}</div>
      );
    },
  
  },
  {
    field: "price",
    headerName: "Total Price (₹)",
    width: 160,
    renderCell: (cellvalues) => {
      // Calculate the total price
      const totalPrice = cellvalues?.row?.price * cellvalues?.row?.quantity;
  
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {totalPrice !== undefined && (
            <Typography variant="body1">{totalPrice}</Typography>
          )}
          <Typography variant="body2"><span className="text-blue f300 " >Price/Unit : ₹{cellvalues?.row?.price}</span></Typography>
        </div>
      );
    },
  }, 
 
    

    {
      field: "is_approved",
      headerName: "Verification Status",
      width: 200,
      renderCell: (cellvalues) => {
        return (
          <>
          <div>{cellvalues?.row?.is_approved===true ?<Tag icon={<CheckCircleOutlined />} color="success">
        Done
      </Tag>
          : <Tag icon={<ClockCircleOutlined />} color="warning">
          Pending
        </Tag>}</div>
          </>
        );
      },
    },
    
  
  ];
  const tableData = {
    rows: stockData,
    columns: columns,
    paginationState: [pagination, setPagination],
    isLoading: isLoading,
    checkboxShowFalse:true

  };
 
  const handleClass = () => {
    if (widthShow) return "col-md-5 mt-2";
    else return "col-md-12";
  };
  
 
  
  return (
   
    <div style={{backgroundColor:"#f8f8f8"}} >
   {isLoading ? (
      <SkeletonLoader />
    ) : stockData?.length > 0 ? (

    <Grid container spacing={2} className="">
        
        {stockData?.map((row, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              variant="outlined"
              sx={{
                padding: 2,
                borderRadius: "12px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.3s",
                "&:hover": { transform: "scale(1.02)" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "center", sm: "flex-start" },
                  marginBottom: 1.5,
                }}
              >
                {row.image_url && (
                  <Box
                    component="img"
                    src={row.image_url}
                    alt={row.crop_name}
                    sx={{
                      width: "70px",
                      height: "70px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      marginBottom: { xs: 1, sm: 0 },
                      marginRight: { sm: 2 },
                    }}
                  />
                )}
      
                <Box sx={{ flex: 1, textAlign: { xs: "center", sm: "left" } }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    {row.crop_name.replace(/_/g, " ")}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "text.secondary" }}>
                    Created: {row.created_at.slice(0, 10)}
                  </Typography>
                </Box>
      
               
              </Box>
      
              <CardContent sx={{ paddingTop: 0 }}>
                {/* Quantity and Price */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: { xs: "column", sm: "row" },
                    flexWrap: "wrap",
                  }}
                >
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>

                    Quantity: <strong>{row.quantity} {row.unit_of_measure}</strong>
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Price/Unit: <strong> ₹ {row.price}</strong>
                  </Typography>
                </Box>
      
              
      
             
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    
                    flexWrap: { xs: "wrap", sm: "nowrap" },
                  }}
                  className="mt-1"
                >
                  <Typography
                    variant="caption"
                    sx={{ fontWeight: 500, color: "#69829f" }}
                  >
                    Verification Status:    <div>{row?.is_approved===true ?<Tag icon={<CheckCircleOutlined />} color="success">
                Done
          </Tag>
          : <Tag icon={<ClockCircleOutlined />} color="warning">
          Pending
        </Tag>}</div>
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, color: "primary.main" }}>
                    Total: ₹ {row.quantity * row.price }
                  </Typography>
                </Box>
      
      
            
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>)
      :<NoData val="trade"/>}

    {/* <div className={handleClass()} >
    <CustomTable
    rows={tableData.rows}
    columns={tableData.columns}
    paginationState={tableData.paginationState}
    loading={tableData.isLoading} 
    checkboxShowFalse={tableData.checkboxShowFalse}

    />
    
    </div> */}
    {/* {widthShow ? (
      <div className="col-lg-7 mt-2">
        <Card>
          <CardHeader style={{ borderBottom: "1px solid #eddddd" }}>
            <h5 className="">
              &nbsp;&nbsp; <b></b> &nbsp; Details &nbsp;
              <i className="mdi mdi-account-details-outline text-primary"></i>
            
            </h5>
          </CardHeader>
          <CardBody style={{ padding: "10px" }}>
              <CreateBuy refetch={refetch} user_id={user_id} UserData={UserData}/>
           
          </CardBody>
        </Card>
      </div>
    ) : (
      ""
    )}
      */}
    </div>
   
    
  );
};

export default BuyerLeadList;
